import React from 'react';
import { Box } from '@mui/material';

const MenuIcon = ({ size = '12px', style, ...props }) => {
    return (
        <Box
            component="img"
            src="/logo/menuLogoImg.png"
            alt="메뉴 아이콘"
            sx={{
                width: size,
                height: size,
                objectFit: 'contain',
                display: 'block',
                ...style
            }}
            {...props}
        />
    );
};

export default MenuIcon;
